module.exports = __webpack_public_path__ + "static/img/platformbg.0dcc31bb.png";